import { useEffect } from 'react';

import { apiGet } from '@/lib/api';
import { useAuthStore, type ManagerRole } from '@/store/auth.store';

interface MeResponse {
  id: string;
  email: string;
  name: string;
  code: string;
  commissionBps: number;
  role: ManagerRole;
  avatarUrl?: string | null;
}

const MIN_INTERVAL_MS = 60_000;
let lastSyncAt = 0;

async function syncProfile(force = false) {
  if (!force && Date.now() - lastSyncAt < MIN_INTERVAL_MS) return;
  lastSyncAt = Date.now();
  try {
    const me = await apiGet<MeResponse>('/me', { silent: true });
    useAuthStore.getState().updateManager({
      name: me.name,
      email: me.email,
      code: me.code,
      commissionBps: me.commissionBps,
      role: me.role,
      avatarUrl: me.avatarUrl ?? null,
    });
  } catch {
    /* 401 разрулит интерцептор, сеть — следующая попытка при возврате во вкладку */
  }
}

/**
 * Роль назначает оператор в sadmin, и бэкенд применяет её сразу. Кабинет
 * подтягивает её при открытии и при возврате во вкладку — меню и разделы
 * главного менеджера появляются без перевхода.
 */
export function useProfileSync(): void {
  useEffect(() => {
    void syncProfile(true);
    const onVisible = () => {
      if (document.visibilityState === 'visible') void syncProfile();
    };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);
    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
    };
  }, []);
}
